import React from "react";

import { Box, Button, Typography } from "@mui/material";
import { MuiColorInput } from "mui-color-input";

import {
  SubtitleStyles,
  BackgroundStyle as BackgroundStyleEnum,
} from "../../../../../../types";

interface BackgroundStyleProps {
  styles: SubtitleStyles;
  onUpdateStyles: (styles: SubtitleStyles) => void;
}

const backgroundStyles = [
  {
    title: "None",
    value: BackgroundStyleEnum.NONE,
    content: "None",
  },
  {
    title: "Full",
    value: BackgroundStyleEnum.FULL,
    content: (
      <Box sx={{ width: "20px", height: "14px", backgroundColor: "#000000" }} />
    ),
  },
];

const getButtonSx = (isSelected: boolean) => ({
  backgroundColor: isSelected ? "rgba(255,255,255,0.15)" : "transparent",
  color: isSelected ? "#4fc3f7" : "rgba(255,255,255,0.6)",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.08)",
    color: "rgba(255,255,255,0.9)",
  },
});

export default function BackgroundStyle({
  styles,
  onUpdateStyles,
}: BackgroundStyleProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <Typography variant="subtitle2">Background Style</Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Box
          sx={{
            border: "1px solid rgba(255,255,255,0.25)",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingX: 1.5,
            paddingY: 0.75,
          }}
        >
          {backgroundStyles.map((bgStyle) => {
            const isSelected = styles.background_style === bgStyle.value;
            return (
              <Button
                key={bgStyle.value}
                title={bgStyle.title}
                sx={getButtonSx(isSelected)}
                onClick={() => {
                  onUpdateStyles({
                    ...styles,
                    background_style: bgStyle.value,
                    // reset outline if background has been selected
                    outline_color:
                      bgStyle.value !== BackgroundStyleEnum.NONE
                        ? undefined
                        : styles.outline_color,
                    outline_thickness:
                      bgStyle.value !== BackgroundStyleEnum.NONE
                        ? undefined
                        : styles.outline_thickness,
                  });
                }}
              >
                {bgStyle.content}
              </Button>
            );
          })}
        </Box>
        <MuiColorInput
          title="Background Color"
          format="hex"
          value={styles.background_color ?? "none"}
          onChange={(value) =>
            onUpdateStyles({ ...styles, background_color: value })
          }
          sx={{
            "& input": {
              width: 0,
              border: "none",
              paddingRight: 0,
            },
            "& fieldset": {
              display: "none",
            },
            "& button": {
              boxShadow: "none",
              borderRadius: "50%",
              width: 34,
              height: 34,
              marginLeft: "8px",
              border: "2px solid rgba(255,255,255,0.4)",
              "&:hover": {
                border: "2px solid rgba(255,255,255,0.8)",
              },
            },
            "& .MuiInputBase-root": {
              padding: 0,
              margin: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
            width: 54,
            height: 54,
          }}
        />
      </Box>
    </Box>
  );
}
